import { createSlice } from "@reduxjs/toolkit";
import { defaultRequestBody, DefaultRequestBodyType } from "../../../constant/document";
import { assignUsers, closeAssignUserModal, closeDeleteTemplateConfirmationModal, closeDeleteUserConfirmationModal, getOrganizationDetail, getUnassignedUsers, openAssignUserModal, openDeleteTemplateConfirmationModal, openDeleteUserConfirmationModal, resetOrganizationDetailPage, unassignUser } from "./OrganizationDetailAction";
import { OrganizationDetailResponseType } from "../../../utils/type";

export interface PaginationType {
  page: number;
  pageSize: number;
  hasMore: boolean;
  loading: boolean;
}
interface AutoRefreshStateType {
  autoRefresh: boolean;
  currentIntervalId: NodeJS.Timer | undefined;
  error: string | undefined;
  loading: boolean;
}
export interface User {
  idUser: number;
  username: string;
  emailAddress: string;
}

interface OrganizationDetailPageStateType {
  data: OrganizationDetailResponseType;
  loading: boolean;
  error: string | undefined;
  currentRequestBody: DefaultRequestBodyType;
  pagination: PaginationType;
  autoRefreshOrganizationDetailState: AutoRefreshStateType;
  success: boolean;
  message: string;
  unassignedUser: User[];
  fetchUnassignedUserLoading: boolean;
  fetchOrganizationDetailLoading: boolean;
  assignUsersLoading: boolean;
  unassignUserLoading: boolean;

  //Modal
  createOrganizationDetailModalState: boolean;
  userDeleteConfirmationModalState: boolean;
  templateDeleteConfirmationModalState: boolean;
}

const OrganizationDetailInitialState: OrganizationDetailPageStateType = {
  data: {
    idTenant: 0,
    name: "",
    createdBy: "",
    dateCreated: "",
    lastUpdatedBy: "",
    dateLastUpdated: "",
    active: true,
    defaultTenant: true,
    mergeSegmentOptions: {
      merge_type: "",
      merge_short_sentence_min_length: 0,
    },
    users: [],
    templates: [],
  },
  assignUsersLoading: false,
  unassignUserLoading: false,
  unassignedUser: [],
  loading: false,
  error: undefined,
  currentRequestBody: defaultRequestBody,
  pagination: {
    page: 2,
    pageSize: 30,
    hasMore: true,
    loading: false,
  },
  autoRefreshOrganizationDetailState: {
    autoRefresh: false,
    currentIntervalId: undefined,
    error: "",
    loading: false,
  },
  success: false,
  message: "",
  fetchUnassignedUserLoading: false,
  fetchOrganizationDetailLoading: false,

  //Modal
  createOrganizationDetailModalState: false,
  userDeleteConfirmationModalState: false,
  templateDeleteConfirmationModalState: false,
};

const OrganizationDetailPageSlice = createSlice({
  initialState: OrganizationDetailInitialState,
  name: "transcribe",
  reducers: {},
  extraReducers(builder) {
    builder
      //Modal
      .addCase(getOrganizationDetail.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getOrganizationDetail.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getOrganizationDetail.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(getUnassignedUsers.pending, (state, action) => {
        state.fetchUnassignedUserLoading = true;
      })
      .addCase(getUnassignedUsers.fulfilled, (state, action) => {
        state.unassignedUser = action.payload;
        state.fetchUnassignedUserLoading = false;
      })
      .addCase(getUnassignedUsers.rejected, (state, action) => {
        state.error = action.error.message;
        state.fetchUnassignedUserLoading = false;
      })
      .addCase(assignUsers.pending, (state, action) => {
        state.assignUsersLoading = true;
      })
      .addCase(assignUsers.fulfilled, (state, action) => {
        state.assignUsersLoading = false;
        state.data = action.payload;
      })
      .addCase(assignUsers.rejected, (state, action) => {
        state.error = action.error.message;
        state.assignUsersLoading = false;
      })
      .addCase(unassignUser.pending, (state, action) => {
        state.unassignUserLoading = true;
      })
      .addCase(unassignUser.fulfilled, (state, action) => {
        state.unassignUserLoading = false;
        state.data = action.payload;
      })
      .addCase(unassignUser.rejected, (state, action) => {
        state.error = action.error.message;
        state.unassignUserLoading = false;
      })

      .addCase(openAssignUserModal, (state, action) => {
        state.createOrganizationDetailModalState = true;
      })
      .addCase(closeAssignUserModal, (state, action) => {
        state.createOrganizationDetailModalState = false;
      })
      .addCase(openDeleteTemplateConfirmationModal, (state, action) => {
        state.templateDeleteConfirmationModalState = true;
      })
      .addCase(closeDeleteTemplateConfirmationModal, (state, action) => {
        state.templateDeleteConfirmationModalState = false;
      })
      .addCase(openDeleteUserConfirmationModal, (state, action) => {
        state.userDeleteConfirmationModalState = true;
      })
      .addCase(closeDeleteUserConfirmationModal, (state, action) => {
        state.userDeleteConfirmationModalState = false;
      });
  },
});

export default OrganizationDetailPageSlice.reducer;
